<iframe
  src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Europe%2FStockholm&bgcolor=%23ffffff&showTitle=0&showPrint=0&src=NTBubXU2cmR2bmlnOGwxbHU5YzJvaWliaDhxNmsxcTlAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%237986CB&mode=AGENDA"
  style="border: solid 1px #777"
  frameborder="0"
  scrolling="yes">
</iframe>
